import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubmitFeedbackRequest } from '../features/settings/settings';
import { ENVIRONMENT } from '../../environments/environment';
import { SaveNotificationRequest } from '../shared/models/rating.model';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  constructor(private http: HttpClient) {}
  private apiUrl: string = ENVIRONMENT.baseUrls.baseAPIUrl;

  submitFeedback(request: SubmitFeedbackRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}Settings/feedback`, request);
  }
  updateUserPassword(userId: number, NewPassword: number): Observable<any> {
    const body = {
      userId: userId,
      NewPassword: NewPassword,
    };
    return this.http.post<any>(
      `${this.apiUrl}Settings/update_user_password`,
      body
    );
  }
  getFeedback(): Observable<any> {
    return this.http.get(`${this.apiUrl}Settings/get_feedback`);
  }
  saveUserNotifications(request: SaveNotificationRequest): Observable<any> {
    return this.http.post(
      `${this.apiUrl}Settings/save_user_notifications`,
      request
    );
  }
  getNotificationSettings(userId: number): Observable<any> {
    const params: any = {
      userId: userId,
    };

    return this.http.get<any>(
      `${this.apiUrl}Settings/get_notifications_by_userId`,
      { params }
    );
  }
  verifyCurrentPassword(userId: number, currentPassword: string): Observable<any> {
    const body = {
      userId: userId,
      CurrentPassword: currentPassword,
    };
    return this.http.post<any>(
      `${this.apiUrl}Settings/verify_current_password`,
      body
    );
  }
}
